import type React from 'react'
import { createContext, useContext, useState } from 'react'

export interface CancelBookingParams {
  hotelName: string
  customerName: string
  startDate?: string
  endDate?: string
  cancellationLimit?: Date
  bookingId: string
}

interface ICancelBookingData {
  toggleCancelBookingModal: () => void
  setData: (data: CancelBookingParams) => void
  payloadData: any | undefined
  isOpen: boolean
}

const CancelBookingContext = createContext<ICancelBookingData>(
  {} as ICancelBookingData,
)

function CancelBookingProvider({
  children,
}: React.PropsWithChildren<object>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)
  const [payloadData, setPayloadData] = useState<CancelBookingParams>()

  function toggle(): void {
    setIsOpen(!isOpen)
  }

  function setData(data: any): void {
    setPayloadData(data)
    toggle()
  }

  return (
    <CancelBookingContext.Provider
      value={{ isOpen, toggleCancelBookingModal: toggle, payloadData, setData }}
    >
      {children}
    </CancelBookingContext.Provider>
  )
}

function useCancelBooking(): ICancelBookingData {
  const context = useContext(CancelBookingContext)

  if (!context) {
    throw new Error(
      'useCancelBooking must be used within an CancelBookingProvider',
    )
  }

  return context
}

export { CancelBookingProvider, useCancelBooking }
